import React from "react";

export function Button({ children, className, onClick }) {
  return (
    <button
      className={`py-2 px-4 rounded transition duration-300 ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
}
